import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-077421db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attributes" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "strength-scale" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {computed, ref, Ref, onMounted} from 'vue'
    import AttributeButton from '../UI/AttributeButton.vue';

    type Attribyte = {
        name:string
        value:string
        children: Array<Attribyte>
        price?:number
        price_id?:number
    }
    interface IProps {
        attributes:Array<Attribyte>
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'AttributesView',
  props: {
    attributes: {}
  },
  emits: ['selected'],
  setup(__props: any, { emit }) {

const props = __props;

    

    let i:Ref<number | null> = ref(null)

    
    function onSelected(id :number, price :number){
        
        emit('selected', id, price)
    }


return (_ctx: any,_cache: any) => {
  const _component_AttributesView = _resolveComponent("AttributesView", true)!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("h3", null, _toDisplayString(props.attributes[0].name[0].toUpperCase() + props.attributes[0].name.slice(1)), 1),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.attributes, (attr, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "attr-values",
            key: index
          }, [
            _createVNode(AttributeButton, {
              attrId: attr.value,
              attrName: attr.name,
              inputType: 'radio'
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  onClick: ($event: any) => {
                        _isRef(i) //@ts-ignore
 ? i.value = index : i = index;
                        _ctx.$emit('selected', props.attributes[_unref(i)].price_id, props.attributes[_unref(i)].price);
                    }
                }, _toDisplayString(attr.value), 9, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["attrId", "attrName"])
          ]))
        }), 128))
      ]),
      (_unref(i) != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (props.attributes[_unref(i)] != undefined && props.attributes[_unref(i)].children.length != 0)
              ? (_openBlock(), _createBlock(_component_AttributesView, {
                  key: 0,
                  onSelected: onSelected,
                  attributes: props.attributes[_unref(i)].children
                }, null, 8, ["attributes"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (props.attributes[0].name.toLowerCase() == 'крепость')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, [
            _createVNode(_component_RouterLink, { to: {name: 'strengthPage'} }, {
              default: _withCtx(() => [
                _createTextVNode("Шкала крепости")
              ]),
              _: 1
            })
          ]),
          _hoisted_7
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})